module.exports = __webpack_public_path__ + "img/User.b0e5fac8.svg";